import { render } from "./CreateSurvey.vue?vue&type=template&id=29b43bfe&scoped=true"
import script from "./CreateSurvey.vue?vue&type=script&lang=js"
export * from "./CreateSurvey.vue?vue&type=script&lang=js"

import "./CreateSurvey.vue?vue&type=style&index=0&id=29b43bfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b43bfe"]])

export default __exports__